import { Stack, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { builder } from "@/builders";
import { columns } from "@/columns/latest-signups";
import { FlowContentContainer } from "@/components/layout/flow-content-container";
import { FlowPaper } from "@/components/layout/flow-paper";
import { FlowTable } from "@/components/layout/flow-table";
import { EmptySlot } from "@/components/staff/shared/empty-slot";
import { useCurrentORG } from "@/components/super-admin/org-management/use-organisation";

export function LatestSignups() {
  const { organization } = useCurrentORG();

  const { data } = useQuery({
    queryKey: builder.data.admin_dashboard.$get({
      organization: organization.id,
    }),
    queryFn: () =>
      builder.$use.data.admin_dashboard({
        organization: organization.id,
      }),
    select: ({ data }) => data.latest_signups,
  });

  return (
    <Stack
      p={20}
      gap={12}
      className="border rounded-lg border-primary-border-light bg-primary-background-white backdrop-blur-sm h-full"
      flex={1}
      mah={450}
    >
      <Title className="prose-xl/medium text-primary-text-body">
        Latest Sign-up
      </Title>
      {data?.length ? (
        <FlowContentContainer>
          <FlowPaper>
            <FlowTable data={data} columns={columns} />
          </FlowPaper>
        </FlowContentContainer>
      ) : (
        <EmptySlot
          title="No data found"
          description="Create a course to get started"
          src="pencil"
        />
      )}
    </Stack>
  );
}
